import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { AwardCompleted } from 'containers/forms/dashboard'

export default class AwardCompletedModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body id={modalId} colorClass={colorClass} narrow noHeader>
        <MaterialModal.Content noFooter noHeader>
          <AwardCompleted {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
